// Width of the project-tree rail. Persisted per browser and published as a CSS
// custom property (`--ws-tree-w`) that every consumer of the rail sizes itself
// against — the AppShell aside and the Worksnips explorer's aside.
//
// The drag/persist/clamp mechanics live in `ui/railWidth` and are shared with
// the Creator Studio step rail; see that file for why the width travels through
// a CSS variable rather than React state.

import { createRail } from '../ui/railWidth';

/** Was a hard-coded 260. Widened 20% — folder trees nest deep enough that the
 *  old rail truncated names three levels down. */
export const DEFAULT_TREE_WIDTH = 312;

export const treeRail = createRail({
  storageKey: 'worksnip:treeRailWidth',
  cssVar: '--ws-tree-w',
  defaultWidth: DEFAULT_TREE_WIDTH,
  min: 220,
  minBody: 480,
});

export const applyTreeWidthVar = treeRail.applyVar;
export const useTreeRailWidth = treeRail.useWidth;
